import { render, staticRenderFns } from "./NewFloor.vue?vue&type=template&id=3d97a735&scoped=true&"
import script from "./NewFloor.vue?vue&type=script&lang=js&"
export * from "./NewFloor.vue?vue&type=script&lang=js&"
import style0 from "./NewFloor.vue?vue&type=style&index=0&id=3d97a735&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d97a735",
  null
  
)

export default component.exports